import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const getGCPAllUsers = async (latestTenant: string, latestprojectId: string) => {

    let url = `${NGROK}/api/gcp/users?tenanatName=${latestTenant}&projectId=${latestprojectId}`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    const flattenedData = Object.values(data).flatMap((item) => item);
    return flattenedData;
};

export const getGCPAllUsersWithRoles = async (latestTenant: string, latestprojectId: string) => {
    let url = `${NGROK}/api/gcp/get-all-user-roles?tenantName=${latestTenant}&projectId=${latestprojectId} `;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};

export const fetchGcpprojectList = async (latestTenant: string) => {
    let url = `${NGROK}/api/gcp/auth/fetchAllProjectIds?tenantName=${latestTenant}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};

